<template>
  <div>
    <base-header class="pb-8 pt-3">
      <!-- Card stats -->
      <b-row>
        <b-col md="3"> </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <b-card class="shadow" no-body>
            <b-card-body> </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Facturas",
  data() {
    return {
      facturas: [],
      cargando: false,
      busqueda: "",
    };
  },
};
</script>
